module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec02_bc2bff28585ed72e4b06590af80ed9bd.jpg";